import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { SiloRealCredentials } from '../../../models/siloreal-credentials.model';
import { SiloRealService } from '../../../services/siloreal.service';

@Component({
  selector: 'ag-siloreal-credentials',
  templateUrl: './siloreal-credentials.component.html',
  styleUrls: ['./siloreal-credentials.component.scss']
})
export class SiloRealCredentialsComponent implements OnInit, OnDestroy {

  @Input() public companyId: number;

  public credentials: SiloRealCredentials = new SiloRealCredentials();
  public loading: boolean = true;
  public processing: boolean = false;
  public saved: boolean = false;
  public error: boolean = false;
  public showPassword: boolean = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private siloRealService: SiloRealService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.siloRealService.get(this.companyId).subscribe({
        next: credentials => {
          if (credentials) this.credentials = credentials;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
        }
      })
    );
  }

  public save(form: any): void {
    if (!form.valid) return;

    this.processing = true;
    this.saved = false;
    this.error = false;

    this.subscriptions.push(
      this.siloRealService.save(this.companyId, this.credentials).subscribe({
        next: credentials => {
          this.credentials = credentials;
          this.processing = false;
          this.saved = true;
        },
        error: () => {
          this.processing = false;
          this.error = true;
        }
      })
    );
  }

  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
